import { Dispatch } from 'react';
import {
  CriteriaListItem,
  CriteriaPaginateList,
  CriteriaResultListParam,
  CriteriaTypeEnum,
} from '../types/criteria-setting';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { forEach } from 'lodash';

export type CreateUpdateCriteriaBody = {
  name: string;
  type: CriteriaTypeEnum;
};

const criteriaEndpoint = '/simulation/criteria-setting';

export const fetchCriteriaResultList = async (
  params: CriteriaResultListParam,
  sortKeys: { key: string; value?: string }[],
  dispatch?: Dispatch<any>,
): Promise<CriteriaPaginateList> => {
  let queryPath = `${ADMIN_URL}${criteriaEndpoint}?`;

  forEach(params, (param, key) => {
    queryPath += param ? `${key}=${param}&` : '';
  });

  forEach(sortKeys, (sortParams, key) => {
    if (sortParams.value) {
      const sortValue = sortParams.value === 'asc' ? 'ascending' : 'descending';
      if (key === 0) {
        queryPath += `${sortParams.key}=${sortValue}&`;
      } else {
        queryPath += `${sortParams.key}=${sortValue}`;
      }
    }
  });

  if (!queryPath.includes('Sort')) queryPath += `lastUpdateDateSort=descending`;

  return apiClient
    .get<CriteriaPaginateList>(queryPath)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchCriteriaItem = async (id: string, dispatch?: Dispatch<any>): Promise<CriteriaListItem> => {
  return apiClient
    .get<CriteriaListItem>(`${ADMIN_URL}${criteriaEndpoint}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const createCriteriaItem = async (body: CreateUpdateCriteriaBody, dispatch?: Dispatch<any>): Promise<void> => {
  return apiClient
    .post<void>(`${ADMIN_URL}${criteriaEndpoint}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const updateCriteriaItem = async (
  id: string,
  body: CreateUpdateCriteriaBody,
  dispatch?: Dispatch<any>,
): Promise<void> => {
  return apiClient
    .put<void>(`${ADMIN_URL}${criteriaEndpoint}/${id}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const deleteCriteriaItem = async (id: string, dispatch?: Dispatch<any>): Promise<void> => {
  return apiClient
    .delete<void>(`${ADMIN_URL}${criteriaEndpoint}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
